import { RpcInboundClient } from '../rpc-inbound-client';
import { RpcManager } from '../rpc-manager';
import { RpcSeek, RpcSeekKey, RpcSeekResult } from './rpc-seek-model';

export class RpcSeekClient {
    /**
     * The seek command.
     *
     * @param rpcManager the rpc manager instance.
     * @param data the seek object.
     * @return Promise<RpcSeekResult> the promise object of seek result.
     */
    public static seek(rpcManager: RpcManager, data: RpcSeek): Promise<RpcSeekResult> {
        return RpcInboundClient.callInbound(rpcManager.rpcChannel, rpcManager.rpcInbound, RpcSeekKey.command, RpcSeekKey.version, data);
    }
}
